import React from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { matchesValues } from "../../util/tableSearch";

/**
 * 공통 표 검색 입력 — 시스템 전 표에서 같은 모양/동작으로 쓰는 단일 검색폼.
 * 필터 로직은 각 표가 `searchMatch(query, [값들])` 로 직접 수행한다(표마다 검색 필드가 달라서).
 *
 * @example
 *   const [q, setQ] = useState("");
 *   <SearchField value={q} onChange={setQ} placeholder="거래처·내용·부서 검색" />
 *   rows.filter(r => searchMatch(q, [r.vendorName, r.title, r.deptName]))
 */
export default function SearchField({ value, onChange, placeholder = "검색", width = 240, sx }) {
    return (
        <TextField
            size="small"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchRoundedIcon sx={{ fontSize: 17, color: "#94a3b8" }} />
                    </InputAdornment>
                ),
                endAdornment: value ? (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={() => onChange("")} sx={{ p: 0.2 }}>
                            <ClearRoundedIcon sx={{ fontSize: 15, color: "#94a3b8" }} />
                        </IconButton>
                    </InputAdornment>
                ) : null,
            }}
            sx={{ width, "& .MuiOutlinedInput-root": { bgcolor: "#f8fafc" }, ...sx }}
        />
    );
}

/**
 * 검색 매칭 — query 가 비었으면 통과, 아니면 values 중 하나라도 부분일치(대소문자 무시).
 *
 * <p>구현은 {@code util/tableSearch} 한 곳에만 둔다. 예전엔 여기와 각 표에 비슷한 필터가 흩어져 있어
 * "이 표는 되는데 저 표는 안 되네" 가 반복됐다. 이 함수는 기존 호출부 호환을 위한 얇은 위임이며,
 * 새 코드는 {@code useTableSearch} 를 쓴다.
 *
 * @param {string} query
 * @param {Array<any>} values  검색 대상 필드 값들
 */
export function searchMatch(query, values) {
    return matchesValues(query, values);
}
